import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 2),
    '& > div:not(:first-child)': {
      marginTop: theme.spacing(1),
    },
  },
  legendEntry: {
    ...theme.typography.body1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.facet.primaryGray,
  },
  legendBubble: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  moreThanTwoBubble: {
    backgroundColor: theme.palette.facet.accentBlue2,
  },
  oneOrTwoBubble: {
    backgroundColor: theme.palette.facet.accentBlue20,
  },
  noneBubble: {
    backgroundColor: theme.palette.facet.mediumGray3,
  },
});

const MobileCalendarLegend = ({
  className,
  classes,
}) => {
  return (
    <div className={classNames(className, classes.root)}>
      <div className={classes.legendEntry}>
        <div className={classNames(classes.legendBubble, classes.moreThanTwoBubble)} />
        {'More than two available times'}
      </div>
      <div className={classes.legendEntry}>
        <div className={classNames(classes.legendBubble, classes.oneOrTwoBubble)} />
        {'One or two available times'}
      </div>
      <div className={classes.legendEntry}>
        <div className={classNames(classes.legendBubble, classes.noneBubble)} />
        {'No available times'}
      </div>
    </div>
  );
};

MobileCalendarLegend.defaultProps = {
  className: '',
};

MobileCalendarLegend.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MobileCalendarLegend);
